import React from 'react';
import { handle400Statuses, sendApiDownloadRequest } from '@services/api';
import { logNetRequest } from '@utils/usefulFuncs';
import { Body5, Container } from '@ui';
import { FlatButton, TransparentFlatButton } from '@ui/buttons';
import ErrorText from '@ui/ErrorText';
import { getDocumentFileType, getDownloadFilename } from './templateDownloadUtils';
import { getTemplateBinaryConfig } from './templateBinaryUtils';

export function TemplateDownloader({ template, onCancel }) {
  const [formError, setFormError] = React.useState(null);
  const [isDownloading, setIsDownloading] = React.useState(false);

  const handleDownloadTemplate = async () => {
    setIsDownloading(true);
    setFormError(null);

    const templateBinaryConfig = getTemplateBinaryConfig(template);
    const url = `v1/genai/templates/${template.id}/${templateBinaryConfig.endpointSuffix}`;
    const response = await sendApiDownloadRequest(url);
    const { status } = response;
    handle400Statuses(status);
    logNetRequest(url, status);

    if (status === 200) {
      const disposition = response.headers?.get('content-disposition') || '';
      const contentType = response.headers?.get('content-type') || '';
      const filenameMatch = disposition.match(/filename[^;=\n]*=["']?([^"';\n]*)["']?/);
      const serverFilename = filenameMatch?.[1] || '';
      const fileType = getDocumentFileType({ template, serverFilename, contentType });
      const downloadFilename = getDownloadFilename({
        template,
        serverFilename,
        extension: fileType.extension,
      });
      const fileData = await response.blob();
      const blob = new Blob([fileData], { type: fileType.mimeType });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = downloadUrl;
      link.download = downloadFilename;
      link.click();
      window.URL.revokeObjectURL(downloadUrl);
      setIsDownloading(false);
      return;
    }

    setIsDownloading(false);
    setFormError('Something went wrong, try again');
  };

  return (
    <Container top={16}>
      <Body5 bold>Download Template</Body5>
      {formError && (
        <Container top={16}>
          <ErrorText>{formError}</ErrorText>
        </Container>
      )}
      <Container top={16} row style={{ gap: '16px' }}>
        <FlatButton disabled={isDownloading} onClick={handleDownloadTemplate}>
          {isDownloading ? 'Downloading...' : 'Download Template'}
        </FlatButton>
        <TransparentFlatButton disabled={isDownloading} onClick={onCancel}>
          Back To Actions
        </TransparentFlatButton>
      </Container>
    </Container>
  );
}
